import styled, { keyframes, css } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

type Props = {
  animateRefreshIcon: boolean
}

const ComponentStyled = styled.div<Props>`
  .create-wish-box {
    max-width: 600px;
    margin: 0 auto;
    position: relative;

    .create-wish-content {
      background-color: ${({ theme }) => theme.colors.secondaries.opacity30};
      padding: 24px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .write-wish-wrapper {
        background: ${({ theme }) => theme.colors.secondaries.opacity10};
        border-radius: 8px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .characters {
          font-family: 'Cabin';
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          letter-spacing: 0.11em;
          color: ${({ theme }) => theme.colors.black};
          margin-bottom: 70px;
        }

        .inspire {
          font-family: 'Cabin';
          font-weight: 700;
          font-size: 20px;
          line-height: 24px;
          display: flex;
          align-items: center;
          letter-spacing: -0.02em;
          color: ${({ theme }) => theme.colors.red};
          cursor: pointer;
          margin-top: 70px;

          .refresh-icon {
            margin-left: 10px;
            animation: ${props =>
              props.animateRefreshIcon
                ? css`
                    ${rotate} 0.25s linear
                  `
                : '0'};
          }
        }
      }

      .next-btn-wrapper {
        margin-top: 25px;
        text-align: center;
      }
    }
  }
`

export default ComponentStyled
